import { render, staticRenderFns } from "./labelToolDetail.vue?vue&type=template&id=289e2b01&scoped=true"
import script from "./labelToolDetail.vue?vue&type=script&lang=js"
export * from "./labelToolDetail.vue?vue&type=script&lang=js"
import style0 from "./labelToolDetail.vue?vue&type=style&index=0&id=289e2b01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e2b01",
  null
  
)

export default component.exports